var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var Svg4UpViewTool = function Svg4UpViewTool(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 34,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    fill: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 36,
    height: 34
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.5 5.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h20a5 5 0 0 1 5 5v13a5 5 0 0 1-5 5H5a5 5 0 0 1-5-5V0Z",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.5 1.5H20A3.5 3.5 0 0 1 23.5 5v13a3.5 3.5 0 0 1-3.5 3.5H5A3.5 3.5 0 0 1 1.5 18V1.5Z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.25 12.25H23.5V18a3.5 3.5 0 0 1-3.5 3.5h-6.75v-9.25Z",
    fill: "#91E7A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.5 12.25h10.25v9.25H5A3.5 3.5 0 0 1 1.5 18v-5.75Z",
    fill: "#FFC1EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.25 1.5H20A3.5 3.5 0 0 1 23.5 5v5.75H13.25V1.5Z",
    fill: "#FFC89C"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#80E0FF",
    x: 1.5,
    y: 1.5,
    width: 10.25,
    height: 9.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 9h3.446C14.304 9 15 9.696 15 10.554v1.892c0 .858-.696 1.554-1.554 1.554h-1.892A1.554 1.554 0 0 1 10 12.446V9Z",
    fill: "#FFF"
  })))));
};

export default Svg4UpViewTool;